import packageJson from '../../../../package.json';
import { environment } from 'src/environments/environment';
export const globalConfig = {
    apiUrl: environment.API_URL,
    apiUrlBackTolis: environment.API_URL_BACKEND_TOLIS,
    azure_key: null,
    tokenApi: 'access_token',
    requesId: 'requestId',
    version: packageJson.version,
    recapchaSiteKey: environment.siteKey,
  };
